module.exports = __webpack_public_path__ + "img/Weapon_284.3b49fef7.png";